import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Data-Table-Generic-Placeholder',
  props: {
  nbRows: { default: 10 }
},
  setup(__props) {



return { __sfc: true, }
}

})